/* Loading placeholders.

   Skeletons are shaped like the content they stand in for, at the same
   dimensions, so nothing moves when the data lands. A generic grey box that is
   replaced by a taller card produces a layout jump — which costs more in
   perceived quality than the spinner it was meant to replace.

   They also deliberately do not animate in. A skeleton that fades in, then
   fades out into content, puts two animations in front of the user before
   anything useful appears. */

interface SkeletonProps {
  w?: string | number
  h?: string | number
  r?: string
  className?: string
}

export function Skeleton({ w = '100%', h = 14, r, className }: SkeletonProps) {
  return (
    <span
      className={`sk ${className ?? ''}`}
      aria-hidden
      style={{
        display: 'block',
        width: typeof w === 'number' ? `${w}px` : w,
        height: typeof h === 'number' ? `${h}px` : h,
        ...(r ? { borderRadius: r } : {}),
      }}
    />
  )
}

/** Matches the landing page's service card: 16:9 photo, then a caption row. */
export function ServiceCardSkeleton() {
  return (
    <span className="lp-service" aria-hidden>
      <span className="lp-service-photo sk" />
      <span className="lp-service-body">
        <Skeleton w="72%" h={14} />
      </span>
    </span>
  )
}

export function MenuRowSkeleton() {
  return (
    <div className="menu-row" aria-hidden>
      <div className="menu-row-text">
        <Skeleton w="42%" h={15} />
        <Skeleton w="72%" h={12} />
        <Skeleton w={60} h={14} />
      </div>
      <Skeleton w={72} h={32} r="var(--r-xs)" />
    </div>
  )
}

/** A screen-reader-only live region so a spinner is not silent. Visual users
 *  see the skeletons; everyone else hears that something is loading. */
export function LoadingAnnounce({ label }: { label: string }) {
  return (
    <span className="sr-only" role="status" aria-live="polite">
      {label}
    </span>
  )
}
